import { QUERY_MOBILE_LANDSCAPE } from '../variables';
export var breakpoints = {
  custom: {
    mobileLandscape: QUERY_MOBILE_LANDSCAPE
  }
};
export default breakpoints;